export const FETCH_SUPERVISOR_WISE_OT_REQUEST = "FETCH_SUPERVISIOR_WISE_OT_REQUEST";
export const FETCH_SUPERVISOR_WISE_OT_SUCCESS = "FETCH_SUPERVISIOR_WISE_OT_SUCCESS";
export const FETCH_SUPERVISOR_WISE_OT_FAILURE = "FETCH_SUPERVISOR_WISE_OT_FAILURE";